export default {
  content88: 'Eliminate the cumbersome manual transfer and complex financial statistics. Integrate the entire process of handling from payment to the management of the recipient on a single platform.',
  content2: 'Make an appointment for a demonstration',
  content3: 'Have a look around',
  content4: 'User Management System',
  content5: 'Home Page',
  content87: 'UXPAY carefully processes every payment.',
  // content6: 'Account',
  // content7: 'Currency exchange',
  // content8: 'Collection of payment',
  // content9: 'Payment',
  // content10: 'Overseas payment',
  // content11: 'Payee',
  // content12: 'User Management',
  // content13: 'Management Center',
  // content14: 'Personal Center',
  // content15: 'View All',
  // content16: 'Overseas payment',
  // content17: 'Download template',
  // content18: 'After downloading the template, fill in the information as required and upload it',
  // content19: 'The system will verify the data. Once it passes the verification, the payment will be submitted',
  // content20: 'The system will automatically identify duplicate file names and duplicate file contents',
  // content21: 'If there are any duplicate prompts, please update the table name or modify the content and resubmit.',
  // content22: 'Single payment',
  // content23: 'Batch Payment',
  // content24: 'Order Number',
  // content25: 'Please enter the order number',
  // content26: 'Receivable Account',
  // content27: 'Please provide the account number for receiving the payment',
  // content28: 'Currency of the remittance',
  // content29: 'Please select the currency for the remittance.',
  // content30: 'Currency of the received funds',
  // content31: 'Please select the currency for the payment',
  // content32: 'Status',
  // content33: 'Please select the status',
  // content34: 'Payment method',
  // content35: 'Please select the payment method',
  // content36: 'Chinese',
  // content37: 'Submission time',
  // content38: 'Please select',
  // content39: 'Completion time',
  // content40: 'Search',
  // content41: 'Clear out',
  // content42: 'Please select the type of payee.',
  // content43: 'Account currency',
  // content44: 'Type of Payee',
  // content45: 'Receiving Account Number',
  // content46: 'Success',
  // content47: 'Creation Date',
  // content48: 'Operation',
  // content49: 'Processing',
  // content50: 'To be collected',
  // content51: 'Cancel',
  // content52: 'Failure',
  // content53: 'Amount of Success',
  content89: 'UXPAY has achieved the automation of payments to individual recipients, reducing the payment time by up to 90%',
  // content55: 'Add payee',
  // content56: 'Account',
  // content57: 'Please enter the registered address of the enterprise',
  content90: 'Collect and verify the information of the payee',
  // content59: 'Transferring',
  content91: 'Real-time update of payment status',
  // content61: 'Account Name',
  // content62: 'Please enter your account name',
  // content63: 'Please enter your account number',
  // content64: 'Currency of payment received',
  content92: 'Directly enter the recipient\'s  information into UXPAY and convert it into a payment',
  // content66: 'Payment amount',
  // content67: 'Available amount',
  // content68: 'Make the payment immediately',
  content93: 'Send global payments and synchronize with your data management system',
  // content70: 'Account name',
  // content71: 'Transaction status',
  content94: 'For each payment, a payment details page is generated in the UXPAY backend, which is updated in real time to show the payment status, and clearly indicates the failure reason for failed orders',
  content95: 'Built-in risk management, marking and blocking suspicious account activities',
  content96: 'Designed for both large and small enterprises',
  content97: 'In the UXPAY system, the entire payment process management, including payment operation, payment status tracking, recipient management, and financial data management, is carried out',
  content98: 'Custom payment remarks',
  content99: 'Embed your application or website with the help of APIs, SDKs and development tools',
  // content78: 'Payment Note',
  // content79: 'Currency',
  // content80: 'Handling fee',
  content100: 'Send quick and flexible payments and support global expansion of customers',
  content101: 'One-stop processing of global payment services, quickly matching your global business needs',
  content102: 'Countries and regions that support direct bank payments of 210+',
  content103: 'Avoid the intermediary and use the cheapest route option to directly transfer the payment to the recipient\'s wallet and bank account',
  // content86: 'Payment to',
  content104: 'The payment method chosen by the payee: wallet, bank account, check, bank card, etc',
  content105: 'Offer your payees a variety of payment options and make payment a competitive advantage for you',
  // content89: 'Please select the payee.',
  // content90: 'Available balance',
  // content91: 'Amount of funds received',
  // content92: 'Wallet',
  // content93: 'Bank account',
  // content94: 'Check',
  // content95: 'VISA',
  content106: 'Customize the transaction fee allocation mechanism according to customer requirements',
  content107: 'Whether you bear the handling fee yourself or have the payee bear it, uxpay can tailor a solution to suit your needs',
  // content98: 'Take the first step in global payment',
  // content99: 'Make an appointment with us to have a personalized demonstration and answer all your questions, or take part in our interactive product tour',
  // content101: 'Make an appointment for a demonstration',
  content108: 'Help you establish cooperative relationships with global influencers',
  content109: 'When you need to link with global influencers, the timely payment of commissions is a crucial aspect in establishing a cooperative relationship. UXPAY has long and excellent service experience in providing payment services for global influencers.',
  // content104: 'Make an appointment for a demonstration',
  // content105: 'Have a look around',
  // content106: 'Fast and flexible payment',
  // content107: 'Payment to',
  // content108: 'Payment method',
  // content109: 'Payment amount',
  // content110: 'Make the payment immediately',
  // content111: 'Diverse payment methods',
  // content112: 'Local bank',
  content110: 'Global Marketing',
  content111: 'In today\'s internet economy, user experience can become a crucial factor in determining the acceptance of your products. uxpay enables you to provide the best payment experience for the recipients, while building user trust through efficient payments.',
  content112: 'Make payments to influencers from over 210 countries and regions',
  content113: 'Multiple real-time payment methods that arrive immediately',
  content114: 'The payment methods favored by Kol: PayPal, Venmo, Cash, ACH, Visa Direct, etc',
  // content118: 'Payment amount',
  // content119: 'Available balance',
  // content120: 'Amount of funds received',
  // content121: 'Make the payment immediately',
  content115: 'Suitable for large-scale payment requirements, assisting your business growth',
  content116: 'Greater business growth means more payment demands. UXPAY can automate payment processes, alleviating the workload and stress on accounts and personnel caused by frequent payment transactions',
  content117: 'Support the option of filling in remarks in the payment information, so that the KOL can clearly know the source of the income',
  content118: 'One-click payment to 1000 key opinion leaders, simplifying the payment workload',
  content119: 'Supports small-amount payments, with the handling fee being much lower than that of bank transfers',
  content120: 'A variety of D0 payment products that arrive in accounts, covering major wallets and accounts, with real-time settlement of commission fees for each transaction',
  content121: 'Global Flexible Employment and Payroll Management',
  content122: 'UXPAY enables you to automate the process of salary payment and supports localized payment methods in over 210 countries',
  // content130: 'Make an appointment for a demonstration',
  // content131: 'Have a look around',
  // content132: 'Distribution successful',
  // content133: 'Automatic distribution successful',
  content123: 'Obstacles encountered in global payroll and flexible employment practices',
  content124: 'Lack of channels in small currency countries',
  content125: 'Countries with small currency denominations have relatively scarce payment channels, yet they are also regions with high demand for labor',
  content126: 'The lack of transparency in exchange rates leads to high exchange rate losses for enterprises',
  content127: 'Using wire transfer for cross-border payments incurs high costs',
  content128: 'No real-time funds transfer available',
  content129: 'Most employers make payments through cross-border transfers, and the funds usually arrive within 2 to 3 days',
  content130: 'The penetration rate of bank accounts in emerging markets is not high, and local wallets need to be used for payment',
  content131: 'Manual processing involves a heavy workload',
  content132: 'Most enterprises use manual transfer methods to distribute salaries, which involves a large amount of work and incurs high labor costs',
  content133: 'There is no unified payment backend for managing the expenditure of salary costs',
  content134: 'Offer multiple payment methods and provide a flexible payment experience',
  content135: 'International bank transfer',
  content136: 'Pay creators from 210+ countries and regions',
  content137: 'Electronic wallets and digital payments, including PayPal, Venmo, and Cash',
  content138: 'Payment channels provided by local banks and wallets in multiple small-currency countries',
  // content150: 'Fast and flexible payment',
  // content151: 'Payment to',
  // content152: 'Payment method',
  // content153: 'Payment amount',
  // content154: 'Available amount',
  // content155: 'Make the payment immediately',
  // content156: 'Support multiple currencies',
  // content157: 'Diverse payment methods',
  // content158: 'International Bank',
  content139: 'Provide payment infrastructure for the global salary distribution of enterprises',
  content140: 'Support adding the payer information in the payment details, so that customers can clearly know the source of their salary',
  content141: 'Simplify the operation process and send all the payments that need to be made with just one click',
  content142: 'Comprehensive system functions provide customers with real-time tracking of payment status and prompt handling of abnormal orders',
  content143: 'Competitive handling fees and exchange rates',
  content144: 'An API integrates global payment methods, significantly enhancing the efficiency of channel integration',
  content145: 'Efficient and rapid API integration',
  content146: 'Solve the difficulties you are currently encountering in the payment process',
  content147: 'Reach out to countries and currencies that your current payment service provider cannot cover',
  content148: 'Provide flexible payment options for receiving salaries to over 210 countries\' employed personnel',
  content149: 'You don\'t need to use different platforms for global payments. UXPAY will handle all the issues for you',
  content150: 'Link your financial system via API, making it convenient for you to manage fund disbursement and conduct financial statistics',
  content151: 'Easily and quickly achieve cooperation with global suppliers',
  content152: 'International suppliers and distributors have opened new channels for your business. However, making payments to them through the banking system will involve complex submission requirements and compliance issues. UXPAY can simplify your payment process, avoid unnecessary compliance risks and complex review materials, and help you make payments to global suppliers quickly through a secure and reliable channel',
  // content172: 'Make an appointment for a demonstration',
  // content173: 'Have a look around',
  // content174: 'Global suppliers',
  // content175: 'International supplier',
  // content176: 'International distributor',
  // content177: 'Receivable Account',
  // content178: 'Payee',
  // content179: 'Currency',
  // content180: 'Payment method',
  // content181: 'Safety and Compliance',
  content153: 'One-click payment to global suppliers',
  content154: 'The products that need to be purchased should not be subject to national boundaries. With the global payment options available, uxpay enables you to make payments to suppliers using the currency and payment method of your choice from anywhere',
  content155: 'Support payment from suppliers in 210+ countries and regions around the world',
  content156: 'A reasonable exchange rate mechanism',
  content157: 'Support payment in the local currencies of small currency countries',
  // content187: 'Global suppliers',
  // content188: 'One-click payment',
  content158: 'Eliminate the cumbersome bank verification process and ensure zero risk for the collection of funds',
  // content190: 'Recharge to',
  // content191: 'Recharge amount',
  // content192: 'Available amount',
  // content193: 'Make a payment immediately',
  content159: 'The complex verification procedures for opening international bank accounts and conducting transactions have always been a significant obstacle for overseas purchasing. With uXPAY, you only need to recharge to our main account, and we will handle the payment to the suppliers on your behalf, eliminating all the complicated and lengthy intermediate processes',
  content160: 'Recharge and payment are quick and easy',
  content161: 'Supports multi-currency global payments, and most of them can be completed with real-time fund arrival through local institutions.',
  content162: 'Secure and reliable sources of funds',
  content163: 'Payment solutions tailored to the characteristics of the gaming industry',
  content164: 'Uxpay Understanding the characteristics of small and frequent payment transactions in the gaming industry, the requirements for timely arrival of funds, as well as the demands for the system\'s high concurrency handling capacity and API. In terms of payment products, fees, settlement cycles, and system development, targeted product adaptations have been made',
  content200: 'Make an appointment for a demonstration',
  content201: 'Have a look around',
  content202: 'Payment method',
  content203: 'Payment amount',
  content204: 'Available balance',
  content205: 'Make the payment immediately',
  content206: 'Amount of funds received',
  content165: 'Whether in the process of global promotion of games or other online platforms, how to achieve localization of payment, real-time processing, and comprehensive coverage of payment methods are all important factors for enhancing user experience',
  content166: 'Payment methods are fully covered',
  content167: 'The overseas wallets, virtual banks and physical bank channels are all very diverse and complex. However, uXPAY continuously enriches various payment channels to help your users receive payments in the way they prefer',
  content168: 'Local Currency',
  content169: 'For global online products, local currency settlement is a necessary condition for meeting the needs of local users. UXPAY has localized the payment channels in major markets, meeting the settlement needs in local currencies for the vast majority of users',
  content170: 'D0 has been credited',
  content171: 'Whether for players, item traders, product promoters, or collaborating streamers, the real-time arrival of payment fees is a crucial aspect in building the trust and popularity of the platform. UXPAY understands this concern and is committed to ensuring the real-time arrival of payments for all types of products',
  content172: 'Uxpay deeply understand customer needs and continuously optimize the product to meet customer requirements',
  content173: 'Full compatibility',
  content174: 'The payment API of UXPAY can meet the requirements of various product types such as games, social applications, and tool applications',
  content175: 'Understanding of customer needs',
  content176: 'UXPAY has served numerous game and overseas application clients, and has a deep understanding of their needs and pain points',
  content177: 'Payment of any amount',
  content178: 'Usually, customers making small payments have to bear a fee that may be higher than the payment amount. UXPAY has a targeted solution for small payment transactions, helping customers optimize their payment costs',
  content179: 'Extremely high payment success rate',
  content180: 'We have continuously optimized various issues in the payment process, which has resulted in an extremely high payment success rate for our payment products',
  content181: 'Payment methods are comprehensive',
  content182: 'Whether it is the supported countries and regions, the supported payment methods, or the supported currencies, uXPAY can meet your needs',
  content183: 'The payment channels of uxpay are all based on professional payment products provided by payment institutions and banks. This ensures that any potential harm caused by risky funds to end-users is completely avoided',
  content6: 'Product',
  content59: 'One click, one api, and easy global payment',
  content60: 'Whether you are a seller, a review service provider, a game publisher, a social product or any other online product, uxpay can support your automated services and help you easily make payments to recipients around the world in the preferred payment method for end user',
  content230: 'Schedule a demonstration',
  content231: 'Have a visit',
  content232: 'USD：6729    HKD：439       HKD：6729389',
  content233: 'View all',
  content234: 'Overseas payment/Batch payment',
  content235: 'Merchant Management System',
  content236: 'Home Page',
  content237: 'Account',
  content238: 'Currency exchange',
  content239: 'Receive payment',
  content240: 'Payment',
  content241: 'Overseas payment',
  content242: 'Payee',
  content243: 'User Management',
  content244: 'Management Center',
  content245: 'Personal Center',
  content246: 'Payee',
  content247: 'Available balance',
  content248: 'Payment amount',
  content249: 'The amount received',
  content250: 'Pay immediately',
  content252: 'Return',
  content253: 'Select the collection type',
  content254: 'Click to visit the file',
  content255: 'Only the file class.xls.xlsx is supported',
  content256: 'Total payment amount',
  content257: 'Handling fee',
  content258: 'Total amount',
  content259: 'Submit',
  content260: 'Usage method',
  content261: '1.After downloading the template, fill it in as required and upload it',
  content262: '2. The system will verify the data. Once approved, the payment will be submitted',
  content263: '3. The system will automatically identify duplicate file names and duplicate file contents',
  content264: '4. If there are duplicate prompts, please update the form name or modify the content and resubmit',
  content265: 'Download the batch payment template',
  content266: 'Batch number',
  content267: 'File name',
  content268: 'Payment method',
  content269: 'Status',
  content270: 'Upload date',
  content271: 'Query',
  content272: 'Clear',
  content273: 'Batch quantity',
  content274: 'Total payment amount',
  content275: 'Handling fee',
  content276: 'Settlement amount',
  content277: 'Payment method',
  content278: 'Remarks',
  content279: 'Submission status',
  content280: 'Operation',
  content281: 'API customization is integrated into your platform',
  content61: 'Expenditures that expand along with your growing business',
  content62: 'As your business and organization continue to expand, the workload and personnel costs required for payment also increase. uxpay payment seamlessly integrates to automate and simplify your existing processes and tools. By choosing uxpay, you will benefit from efficient global payments, reduced operating costs, and our user-friendly api to enhance your payment capabilities.',
  content63: 'Choose single payment or batch payment',
  content64: 'Fill in the information of the receiving account',
  content65: 'Multiple payment methods are available to send payments anywhere',
  content287: 'Select the payment method',
  content66: 'Natively synchronize data to the platform or connect to other systems via API',
  content67: 'Send payments anywhere and send automation to uxpay',
  content68: 'In a decentralized world, enterprises need to make large-scale payments on a global scale. uxpay is a powerful payment platform and API. We automate payments through the api and connect you to markets in 210 countries around the world.',
  content69: 'Flexible payment options in over 210 countries and regions',
  content70: 'uxpay integrates multiple payment methods such as bank transfer, checking account payment, and wallet payment, providing the preferred collection method for recipients in the target market',
  content71: 'Simplified workflow and payment automation',
  content72: 'Customize the design of payment functions that match your business processes and seamlessly integrate with your operation system',
  content73: 'Easily provide a simple recharge process for your payment',
  content74: 'Recharge your account through bank account transfer, and it also supports mutual transfer between uxpay wallets, making it easy to inject funds into the payment agency account',
  content75: 'Let your recipient freely choose the payment method they like',
  content76: 'Provide sufficient flexibility for your payment operations, while integrating all payment methods on one platform and centrally managing customer payments',
  content77: 'Payment can be made to paypal, venmo or cash wallet',
  content78: 'Direct payment by visa card',
  content79: 'Local bank account',
  content302: 'Payee',
  content303: 'Payment amount',
  content304: 'Available balance',
  content305: 'The amount received',
  content306: 'Pay immediately',
  content307: 'Please select the payment method',
  content82: 'Support single payment in the background',
  content83: 'Support the transmission of payment requests via api and synchronize them to the uxpay system',
  content84: 'Support the import of excel documents from the background and batch payment',
  content80: 'uxpay ADAPTS to all your payment operation methods',
  content81: 'Payment requests are supported to be initiated 24/7. uxpay ensures that you can set it up at any time, allowing your payee to receive the payment at any time',
  content85: 'Support payment bill inquiry and provide transaction vouchers',
  content86: 'uxpay understands that there is anxiety between remitting money from your account and the recipient\'s account in theirs. This is why we send a white-label email to your recipient to inform them that the money has been sent. In addition, you can track the real-time status of any payment in the uxpay backend, thereby reducing the burden on the operation team.',
  content316: 'Bill',
  content7: 'Platform',
  content9: 'Commission payment for global Internet celebrities and Kols',
  content10: 'Global salary distribution',
  content12: 'Games, social and tool products',
  content17: 'Global localized payment service solutions',
  content18: 'We provide you with a one-stop local payment service solution to help you expand your business worldwide and better explore new markets',
  content328: 'Schedule a demonstration',
  content329: 'Have a visit',
  content330: 'USD：6729    HKD：439       HKD：6729389',
  content331: 'View all',
  content332: 'Merchant Management System',
  content333: 'Home Page',
  content334: 'Account',
  content335: 'Currency exchange',
  content336: 'Receive payment',
  content337: 'Payment',
  content338: 'User Management',
  content339: 'Management Center',
  content340: 'Personal Center',
  content341: 'Payment amount',
  content342: 'Apply for an account',
  content343: 'Recharge application',
  content344: 'Initiate payment',
  content345: 'Currency exchange',
  content346: 'Withdrawal application',
  content347: 'Payment record',
  content348: 'Transaction statistics amount',
  content349: 'Amount',
  content350: 'Number of strokes',
  content351: 'In the past week',
  content352: 'In the past month',
  content353: 'Exchange',
  content354: 'Receive payment',
  content355: 'Remittance',
  content356: 'Transaction statistics',
  content357: 'International remittance',
  content358: 'Collection management',
  content359: 'Currency exchange',
  content360: 'My to-do list',
  content361: 'Multi-currency global receiving account',
  content19: 'Worldwide, payments are provided to over 210 countries and regions',
  content501: 'Worldwide,',
  content500: 'payments are provided to over 210 countries and regions',
  content363: 'Payee',
  content364: 'Payment amount',
  content365: 'The amount received',
  content366: 'Pay immediately',
  content20: 'Payment successful',
  content368: 'Return',
  content21: 'End-to-end payment automation',
  content22: 'Automatically complete the payee\'s joining and payment through a payment system, providing a seamless experience for the payee.',
  content23: 'Payment',
  content26: 'Send payments quickly to anywhere in the world',
  content27: 'Access the most extensive global payment network, provide recipients with flexible payment options, and complete payments faster than ever before',
  content28: 'The funds were sent to over 210 countries and regions',
  content29: 'Provide a variety of real-time arrival products (such as paypal, cash, venmo, visa direct, sepa-instant, etc.)',
  content30: 'Support payment with mainstream wallets to avoid high handling fees charged by banks',
  content31: 'Supports api automatic payment, and also supports batch manual payment by uploading excel in the background',
  content32: 'The payment status is updated in real time in the background, and abnormal orders are handled promptly',
  content379: 'Receiving account',
  content380: 'Account name',
  content381: 'Transaction status      ---Success',
  content382: 'Payment method',
  content383: 'Payment amount',
  content384: 'The amount received',
  content385: 'Single transaction fee',
  content386: 'Currency type',
  content387: 'Payment amount',
  content388: 'Receiving account',
  content389: 'Payment method',
  content24: 'System',
  content33: 'uxpay is synchronized in real time with your business system',
  content34: 'The built-in integration of uxpay reduces manual data reconciliation, prevents duplicate errors, and provides comprehensive payment data information to make business decisions more quickly',
  content35: 'Support the creation of payment orders and the integration of payment information in your system through api',
  content36: 'Update the payment status in real time and handle abnormal orders promptly',
  content37: 'Ensure the accuracy and real-time nature of the data and synchronize it with your financial system in real time',
  content38: 'Powerful system integration, matching various business systems',
  content397: 'Paid',
  content398: 'Connect to QuickBooksOnline',
  content399: 'You will be required to connect your QuickBooksOnline account and authorize uxpay to access the following data;',
  content400: 'Receivables information',
  content401: 'Payables information',
  content402: 'Account information',
  content403: 'Synchronous success',
  content404: 'Upload a file',
  content405: 'API',
  content39: 'Establish a powerful integrated payment system',
  content40: 'Build a customized payment experience through uxpay’s ready-to-use API. Automatically trigger payments and keep the latest payment data on your platform',
  content41: 'Continuously extend the system functions and expand the business modules',
  content42: 'Provide a sandbox environment for development and testing',
  content43: 'Support complete API documentation',
  content411: 'Display 4,867 API log entries',
  content412: 'Filter',
  content25: 'Safety',
  content44: 'Trust and security run through every step',
  content45: 'We manage our clients‘ funds and data in accordance with the highest global standards. uxpay operates in the most sensitive way. We constantly optimize our policies to understand and prevent fraud.',
  content46: 'A powerful toolkit, including a global monitoring list, risk score, 2FA access, and a user role and permission management system',
  content47: 'Bank-level security and encryption, tokenized data, and secure servers',
  content48: 'Complies with SOC2, GDPR, EU-US privacy protection and CCPA standards',
  content420: 'Recipient',
  content421: 'Transfer money',
  content422: 'Settings',
  content423: 'Account',
  content424: 'Your payment has been safely completed',
  content425: 'The average is less than 50,000 lines of code',
  content426: 'Simplify your architecture',
  content427: 'Payment to',
  content428: 'Payment amount',
  content429: 'Available amount',
  content430: 'Pay immediately',
  content49: 'An api links global payments',
  content50: 'Powerful, ready-to-deploy development tools and fully flexible apis: the top choice for developers and product managers. uxpay can be customized and integrated into your platform through a single line of code or at the API level.',
  content51: 'Our victory is measured by the success of our customers',
  content52: 'Customers can focus on business operations and do not need to invest resources and manpower in handling payment work. uxpay assists customers in handling payment procedures and managing payment data',
  content53: 'Three days',
  content54: 'The average reduction of the payment cycle',
  content437: '0.9',
  content55: 'Reduce financial and management time',
  content439: '0.75',
  content56: 'Less wallet or transfer fees',
  content441: 'Master local payment methods around the world and explore new business opportunities',
  content442: 'Supported countries and regions',
  content443: 'Electronic wallet',
  content444: 'Real-time payment',
  content445: 'Bank transfer',
  content446: 'More payment methods',
  content447: 'Asia',
  content448: 'Chinese mainland',
  content449: 'Japan',
  content450: 'Hong Kong',
  content451: 'Vietnam',
  content452: 'Europe',
  content453: 'Britain',
  content454: 'France',
  content455: 'Italy',
  content456: 'Germany',
  content457: 'Oceania',
  content458: 'Australia',
  content459: 'North America',
  content460: 'Canada',
  content461: 'The United States',
  content462: 'South America',
  content463: 'Brazil',
  content464: 'Take the first step towards global payment',
  content465: 'Make an appointment with us for a personalized demonstration and answer all your questions, or join our interactive product tour',
  content14: 'Free trial',
  content467: 'Schedule a demonstration',
  content57: 'Contact information',
  content469: 'If you would like to discuss our products with us or you would like us to understand your needs, please contact us',
  content58: 'wechat',
  content15: 'Email',
  content16: 'Contact us',
  content8: 'Industry solutions',
  content11: 'Global supplier payment',
  content184: 'Regarding uxpay',
  content185: 'We offer a one-stop local payment service solution. Uxpay is an end-to-end payment ecosystem that enables enterprises to send quick payments to all over the world effortlessly',
  content186: 'Our story',
  content187: 'UXPAY has built a cloud-based payment platform, enabling enterprises to make payments to individuals or companies in any currency and using all major payment methods globally. Our powerful payment API allows enterprises to access our extensive global banking and payment network',
  content188: 'The uxpay team has extensive experience in global payment services and is passionate about financial technology and payments. We are motivated by a problem that all enterprises encounter: sending payments',
  content189: 'The vision of UXPAY is to establish a genuine global payment ecosystem, thereby unlocking the collective economic opportunities of the Internet for everyone. Our mission is to build the payment infrastructure for the Internet economy. We enable enterprises to reach users and partners from all over the world',
  content190: 'What can you do with UXPAY',
  content191: 'Automated payment sending and management',
  content192: 'Full-scenario coverage, payment worry-free',
  content193: 'An API links global payment methods',
  content194: 'Efficient payment processing speed',
  content195: 'Please contact us to discuss the business situation and obtain the invitation code',
  content196: 'Scan code contact us',
  content13: 'About Us',
}